export enum MenuSectionNames {
  Communications = 'communications',
  Limited = 'limited',
  Additionally = 'additionally',
  Single = 'Single'
}
